@if (data && data.ShowSearchBox) {
  <app-search-box></app-search-box>
}
@if (data) {
  <div class="container">
    <div class="content">
      <app-inner-html [html]="data.Description"></app-inner-html>
    </div>
    @if (data.ShowLocations) {
      <div class="list-container">
        <app-inner-html [html]="data.ListHeader"></app-inner-html>
        @for (location of locationsWithImage; track location) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + location.Url">
              @if (location.Media && location.Media.Url) {
                <img
                  [src]="
                    location.Media.Url
                      | apiImage: 350 : location.Media : 'fill' : 350
                  "
                  [alt]="location.Name"
                  loading="lazy"
                  [height]="350"
                  [width]="350"
                />
              }
              <p>{{ location.Name }}</p>
              <span>
                {{ location.ShortDescription }}
              </span>
            </a>
          </div>
        }
        @for (location of locationsWithoutImage; track location) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + location.Url">
              <p>{{ location.Name }}</p>
            </a>
          </div>
        }
      </div>
    }
    @if (data.ShowPois) {
      <div class="list-container">
        <app-inner-html [html]="data.ListHeader"></app-inner-html>
        @for (poi of poisWithImage; track poi) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + poi.Url">
              @if (poi.Media && poi.Media.Url) {
                <img
                  [src]="
                    poi.Media.Url | apiImage: 350 : poi.Media : 'fill' : 350
                  "
                  [alt]="poi.Name"
                  loading="lazy"
                  [height]="350"
                  [width]="350"
                />
              }
              <p>{{ poi.Name }}</p>
              <span>{{ poi.ShortDescription }}</span>
            </a>
          </div>
        }
        @for (poi of poisWithoutImage; track poi) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + poi.Url">
              <span>{{ poi.Name }}</span>
            </a>
          </div>
        }
      </div>
    }
    @if (data.ShowPropertyTypes) {
      <div class="list-container">
        <app-inner-html [html]="data.ListHeader"></app-inner-html>
        @for (poi of propertyTypesWithImage; track poi) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + poi.Url">
              @if (poi.Media && poi.Media.Url) {
                <img
                  [src]="
                    poi.Media.Url | apiImage: 350 : poi.Media : 'fill' : 350
                  "
                  [alt]="poi.Name"
                  loading="lazy"
                  [height]="350"
                  [width]="350"
                />
              }
              <p>{{ poi.Name }}</p>
              <span>{{ poi.ShortDescription }}</span>
            </a>
          </div>
        }
        @for (poi of propertyTypesWithoutImage; track poi) {
          <div class="list-wrapper">
            <a class="list" [routerLink]="'/' + poi.Url">
              <span>{{ poi.Name }}</span>
            </a>
          </div>
        }
      </div>
    }
    @if (data.ShowTopProperties && data.TopProperties) {
      <div class="list-container">
        <app-inner-html [html]="data.ListHeader"></app-inner-html>
        <div id="property-list">
          @for (property of data.TopProperties; track property) {
            <app-property-list-property
              [property]="property"
              [settings]="settings"
            ></app-property-list-property>
            <!-- <div class="property">
              <a
                [routerLink]="'/hotell/' + property.Url"
                attr.aria-label="{{ property.Name }}"
              >
                <div class="image-container">
                  <div class="image-wrapper">
                    @if (property.TopMedia && property.TopMedia.Url) {
                      <img
                        [src]="
                          property.TopMedia.Url
                            | apiImage: 305 : property.TopMedia : 'fill' : 305
                        "
                        [alt]="property.Name"
                        loading="lazy"
                        [height]="305"
                        [width]="305"
                      />
                    }
                  </div>
                  <div class="ribbon">
                    <span>
                      <span>★</span>
                      <span>★</span>
                      <span>★</span>
                      <span>★</span>
                    </span>
                  </div>
                </div>
                <div class="content">
                  <div class="name">
                    {{ property.Name }}
                  </div>
                  <div class="description">
                    {{ property.ShortDescription }}
                  </div>
                </div>
              </a>
            </div> -->
          }
        </div>
      </div>
    }
  </div>
}
